// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"48":"route-team","942":"route-home"}[chunkId] + "." + __webpack_require__.h() + ".css";
};